





















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Event } from '../interfaces/event.interface';
import SearchFilter from '@/modules/events/components/SearchFilter.vue';
import { namespace } from 'vuex-class';
import EventModal from '@/modules/events/components/EventModal.vue';
import EventCard from '@/modules/events/views/EventCard.vue';
import EventModalDetails from '@/modules/events/components/EventDetailsModal.vue';

const eventStore = namespace('EventStore');
const userStore = namespace('UserStore');

@Component({
  name: 'Home',
  components: {
    EventCard,
    SearchFilter,
    EventModal,
    EventModalDetails,
  },
})
export default class Home extends Vue {
  @eventStore.Action
  updateEventModalVisibility!: (showEventModal: boolean) => void;
  @eventStore.State
  private events!: Event[];
  @eventStore.Action
  private getEvents!: (params: URLSearchParams | void) => void;
  @userStore.Getter
  private isLogged!: boolean;

  getUpdatedEvents(params: URLSearchParams) {
    this.getEvents(params);
  }

  mounted() {
    this.getEvents();
    setInterval(this.getEvents, 60000);
  }
}
